import { render, staticRenderFns } from "./Submittals.vue?vue&type=template&id=883cb890&scoped=true&lang=pug&"
import script from "./Submittals.vue?vue&type=script&lang=js&"
export * from "./Submittals.vue?vue&type=script&lang=js&"
import style0 from "./Submittals.vue?vue&type=style&index=0&id=883cb890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883cb890",
  null
  
)

export default component.exports